module.exports = __webpack_public_path__ + "img/jt4.d8841696.png";